import React from 'react';
import { AlertCircle, Wifi } from 'lucide-react';
import WebStepShell from './WebStepShell';
import DeviceMedia from './DeviceMedia';
import type { WebFlowCtx } from './types';

interface Props {
  ctx: WebFlowCtx;
}

const Step5ConnectInternet: React.FC<Props> = ({ ctx }) => (
  <WebStepShell
    step="internet"
    onHeaderBack={ctx.openExitModal}
    onCancel={ctx.openExitModal}
    secondary={{ label: 'Cancel', onClick: ctx.openExitModal, disabled: ctx.loading }}
    primary={{
      label: "I'm Connected",
      onClick: ctx.connectInternet,
      loading: ctx.loading,
      loadingLabel: 'Verifying…',
    }}
    media={<DeviceMedia indicator="step1" />}
  >
    <p className="dcfw-eyebrow">SETUP PHASE 5</p>
    <h2 className="dcfw-title">Step 5 of 6: Connect to the internet</h2>

    <div className="dcf-status-icon-container">
      <div className="dcf-status-icon dcf-status-icon--neutral">
        <Wifi size={32} />
      </div>
      <p className="dcf-status-icon-text">Connect to internet</p>
    </div>

    <p className="dcf-step-subtitle-head" style={{ marginTop: 12 }}>
      Reconnect your computer to the internet
    </p>
    <p className="dcf-step-subtitle">
      Go to <strong>Settings &rarr; Wi-Fi</strong> and reconnect this computer to your
      normal internet network, then come back and click{' '}
      <strong>&ldquo;I&apos;m Connected&rdquo;</strong>.
    </p>

    {ctx.internetError && (
      <div className="dcf-banner dcf-banner--error" style={{ marginTop: 8 }}>
        <AlertCircle size={20} color="#D2042D" className="flex-shrink-0" />
        <div className="dcf-banner-description">
          <span>{ctx.internetError}</span>
        </div>
      </div>
    )}
  </WebStepShell>
);

export default Step5ConnectInternet;
